import { render, staticRenderFns } from "./SelfMessages.vue?vue&type=template&id=3c211455&"
import script from "./SelfMessages.vue?vue&type=script&lang=js&"
export * from "./SelfMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports